/**
 * The EROS wordmark: the name set wide in Archivo on a brass hang tag with a punched
 * hole. Replace via config/brand.ts (clientLogoUrl) once the client's logo is known.
 */
import { BRAND } from '../../config/brand';
import { cx } from '../../components/ui';

export function TagGlyph({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden className={className}>
      <path d="M11 4h15a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H11l-7-12z" fill="rgb(var(--brass))" />
      <circle cx="11.5" cy="16" r="2.6" fill="rgb(var(--rail))" />
      <path d="M17 11h7M17 16h5M17 21h7" stroke="rgb(var(--rail))" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}

export function Wordmark({ compact, onDark, className }: { compact?: boolean; onDark?: boolean; className?: string }) {
  if (BRAND.clientLogoUrl) return <img src={BRAND.clientLogoUrl} alt={BRAND.clientName || BRAND.product} className={cx('h-8 w-auto', className)} />;
  return (
    <span className={cx('inline-flex items-center gap-2.5', className)}>
      <TagGlyph className="h-8 w-8 shrink-0" />
      {!compact && (
        <span className={cx('display text-[22px] tracking-[0.14em]', onDark ? 'text-rail-ink' : 'text-ink')} style={{ fontStretch: '125%' }}>
          {BRAND.product}
        </span>
      )}
    </span>
  );
}
